// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'

export const setLoading = createAsyncThunk('vendorPref/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('vendorPref/getData', async (params, { dispatch }) => {
    dispatch(setLoading({ getData: true }))

    const response = await axios.get('/Prefrences/GetVendorFormMandatoryFields', { params })

    dispatch(setLoading({ getData: false }))
    return {
        params,
        data: response.data,
    }
})

export const vendorPref = createSlice({
    name: 'vendorPref',
    initialState: {
        data: [],
        codeCustomization: {},
        totalRecords: 1,
        params: {},
        loadingState: { getData: false, getCodeCustomization: false }
        // allData: []
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getData.fulfilled, (state, action) => {
                state.data = action.payload.data.data
                state.totalRecords = action.payload.data.totalRecords
                state.params = action.payload.params
            })
            .addCase(setLoading.fulfilled, (state, action) => {
                state.loadingState = action.payload
            })
    }
})

export default vendorPref.reducer
